module.exports = __webpack_public_path__ + "static/ebr-14-916225b22ece743ae1463029fd8d5ed3.jpg";